 



import React, { useState, useEffect,useRef } from "react";
 
import {  fetchHiringRequests, fetchHiringManagers, GetDemandPlanning,  SaveCandidate,GetCandidateByRequestId, fetchActiveDepartments } from "../services/apiService"; // Import the API service for roles
import Select from 'react-select'; // Import react-select
import {   getDepartmentIdFromToken,getUserFromToken, getToken, getRoleFromToken } from '../services/authService';
// In App.js or the main entry component
 
 
import * as pdfjsLib from 'pdfjs-dist';
import NationalityList from "../components/NationalityList";
import nationalities from "../components/nationalities";
import CandidatesModal from "../components/CandidatesModal";
import FlipCard from "../components/FlipCard";
import QuickAddCandidateModal from "./QuickAddCandidateModal";

 
 import { toast } from "react-hot-toast";
import JobDescription from "../components/JobDescription";

 
 
 


const AddCandidateForm = ({ requestId,companyCode, onClose ,nationalities }) => {
  const [candidate, setCandidate] = useState({
    full_name: "",
    email: "",
    phone_number: "",
    date_of_birth: "",
    gender: "",
    nationality: "",
    is_citizen: false,
    is_transfer_ownership: false,
     is_new_visa: false,
    source_of_cv: "",
    status: "Created",
    highest_degree: "",
    major: "",
    institute_name: "",
    completion_year: "",
    descriptions: "",
    company_name: "",
    reason_for_leaving: "",
    experience_years: "",
    experience_years_at_ksa: "",
    last_job_title: "",
    last_salary: "",
    expected_salary: "",
      companyCode: companyCode,
    request_id :requestId,
    Documents: {
        FileName: "",
        FileBase64: "",
        Size: 0,
        MimeType: "",
        reference_id: "0",
        process_type: "",
        uploaded_by: "",
        uploaded_at: "", // or null if you're using Date object
        IsActive: true
      }
   
  });
  
 
  const [currentStep, setCurrentStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [textContent, setTextContent] = useState("");
  const [error, setError] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalSubmitOpen, setIsModalSubmitOpen] = useState(false); // Modal visibility state
  const [isSubmitConfirmed, setIsSubmitConfirmed] = useState(false); 
  const [searchTerm, setSearchTerm] = useState(''); // Search term state
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
const [activeTab, setActiveTab] = React.useState("personal"); // Default tab

  useEffect(() => {
    pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js`;
  }, []);

const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  // Define mutually exclusive checkbox names
  const exclusiveFields = ['is_citizen', 'is_transfer_ownership', 'is_new_visa'];

  if (type === 'checkbox' && exclusiveFields.includes(name)) {
    setCandidate((prev) => {
      const updated = { ...prev };

      // Uncheck all exclusive checkboxes
      exclusiveFields.forEach((field) => {
        updated[field] = false;
      });

      // Check only the selected one
      updated[name] = checked;

      return updated;
    });
  } else {
    setCandidate((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  }
};

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    //  setCandidate((prev) => ({ ...prev, Documents: null }));
    const userName = getUserFromToken();
      const validTypes = [
    "application/pdf",
    "image/png",
    "image/jpeg",
    "image/jpg"
 
  ];
    if (!file) {
          toast.error("No file selected.");
          return;
        }

            if (!validTypes.includes(file.type)) {
                toast.error("Invalid file type. Only PDF or image files are allowed.");
                 e.target.value = null;
                return;
              }
            
              if (file.size > 5 * 1024 * 1024) { // 5MB limit
                toast.error("File size exceeds 5MB. Please upload a smaller file.");
                 e.target.value = null;
                return;
              }
    if (file && file.type === "application/pdf") {
     
  
      const reader = new FileReader();
  
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
  
        setCandidate((prev) => ({
          ...prev,
       
          Documents: {
            FileName: file.name,
            FileBase64: base64String,
            Size: file.size,
            MimeType: file.type,
            reference_id: "0", // Fill in if you have a ref ID
            process_type: "Resume", // Example process type
            uploaded_by: userName, // Replace with logged-in user name or ID
            uploaded_at: new Date().toISOString(), // Store the current timestamp
            IsActive: true
          }
        }));
  
        setTextContent("");
        setError("");
      };
  
      reader.readAsDataURL(file);
    } else {
      setError("Please upload a valid PDF file.");
    }
  };
  
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closesubmitModal = () => {
    setIsModalSubmitOpen(false);
  };
  
  const handleFinishClick = () => {
    setIsModalSubmitOpen(true); // Show the modal when the "Finish" button is clicked
  };
 

  const filteredNationalities = nationalities.filter((nationality) =>
    nationality.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  

  // Handle nationality selection
  const handleSelectNationality = (nationality) => {
    setCandidate((prevCandidate) => ({
      ...prevCandidate,
      nationality: nationality.label, // Store the selected nationality value
    
    }));
    setSearchTerm(nationality.label); // Optionally, set search term to the selected nationality
    setIsDropdownVisible(false); // Hide the dropdown after selection
  };
  const autoFillFields = (text) => {
    const phoneRegex = /\b(?:mobile|mob|phone|contact|phone\s?number|contact\s?number)\s?:?\s?[\+\d\(\)\-\s]{10,15}\b/gi;
    const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;
    const dateOfBirthRegex = /(?:\d{1,2}[-/])?\d{1,2}[-/]\d{4}|\d{4}[-/]\d{1,2}[-/]\d{1,2}/;
    const genderRegex = /\b(gender|sex)\s*[:\-]?\s*(Male|Female|Other)\b/gi;
    const nameRegex = /\b[A-Z][a-z]+(?:\s[A-Z][a-z]+){0,2}\b/g;

    const phoneMatch = text.match(phoneRegex);
    const emailMatch = text.match(emailRegex);
    const dateOfBRegex = text.match(dateOfBirthRegex);
    const genderMatch = text.match(genderRegex);
    const nameMatch = text.match(nameRegex);

    if (phoneMatch) setCandidate((prev) => ({ ...prev, phone_number: phoneMatch[0] }));
    if (emailMatch) setCandidate((prev) => ({ ...prev, email: emailMatch[0] }));
    if (dateOfBRegex) setCandidate((prev) => ({ ...prev, date_of_birth: dateOfBRegex[0] }));
    if (genderMatch) setCandidate((prev) => ({ ...prev, gender: genderMatch[0] }));
    if (nameMatch) setCandidate((prev) => ({ ...prev, full_name: nameMatch[0] }));
  };
  const cleanNumericFields = (candidate) => {
  const fields = ["experience_years", "experience_years_at_ksa", "last_salary", "expected_salary"];

  const cleaned = { ...candidate };

  fields.forEach((field) => {
    const value = cleaned[field];
    if (value === "" || value == null || isNaN(value)) {
      cleaned[field] = null;
    } else {
      cleaned[field] = Number(value);
    }
  });

  return cleaned;
};

  const validateCandidate = () => {
    const newErrors = {};

    if (!candidate.full_name) newErrors.full_name = 'Full Name is required.';
    if (!candidate.email) newErrors.email = 'Email is required.';
    if (!candidate.phone_number) newErrors.phone_number = 'Phone Number is required.';
    if (!candidate.date_of_birth) newErrors.date_of_birth = 'Date of Birth is required.';
    if (!candidate.gender) newErrors.gender = 'Gender is required.';
    if (!candidate.nationality) newErrors.nationality = 'Nationality is required.';
    if (!candidate.source_of_cv) newErrors.source_of_cv = 'Source Of CV is required.';
    //if (!candidate.highest_degree) newErrors.highest_degree = 'Highest Degree is required.';
   // if (!candidate.major) newErrors.major = 'Major is required.';
    //if (!candidate.institute_name) newErrors.institute_name = 'Institute Name is required.';
    //if (!candidate.completion_year) newErrors.completion_year = 'Completion Year is required.';
    //if (!candidate.company_name) newErrors.company_name = 'Company Name is required.';
   // if (!candidate.reason_for_leaving) newErrors.reason_for_leaving = 'Reason for Leaving is required.';
    //if (!candidate.experience_years) newErrors.experience_years = 'Years of Experience is required.';
    //if (!candidate.experience_years_at_ksa) newErrors.experience_years_at_ksa = 'Years of Experience in KSA is required.';
    //if (!candidate.last_job_title) newErrors.last_job_title = 'Last Job Title is required.';
    //if (!candidate.last_salary) newErrors.last_salary = 'Last Salary is required.';
   // if (!candidate.expected_salary) newErrors.expected_salary = 'Expected salary is required.';
    
    if (!candidate.Documents.FileName) newErrors.resume = 'Resume is required.';

    //if (isNaN(candidate.experience_years)) newErrors.experience_years = 'Experience Years must be a number.';
    //if (isNaN(candidate.last_salary)) newErrors.last_salary = 'Last Salary must be a number.';
    if (isNaN(candidate.expected_salary)) newErrors.expected_salary = 'Expected salary must be a number.';
    if (isNaN(candidate.phone_number)) newErrors.phone_number = 'Last Salary must be a number.';
    
    return newErrors;
  };
  
  const handleSubmit = async (e) => {
    if (isSubmitConfirmed) return;
    e.preventDefault();
  
    // Validate candidate data
    const errors = validateCandidate();
   
    // If there are validation errors, set them to state and stop submission
    if (Object.keys(errors).length > 0) {
      setErrors(errors);  // Set the errors to state for displaying error messages
      return;
    }
  
    // Clear previous errors before submission
    setErrors({});
  
    try {
        
      // Disable the submit button (optional but recommended for UX)
      // Disable the form submission button here if you're using one
      setIsSubmitConfirmed(true); 
      const userName = getUserFromToken();
      candidate.created_by=userName;
      candidate.Documents.uploaded_by=userName;

      
      
      // Make the API call to add the candidate
      const cleanedCandidate = cleanNumericFields(candidate);
      const savedRequest = await SaveCandidate(cleanedCandidate);
  
      // Check the response status to handle errors or success
      if (Number(savedRequest.status) === 400) {
        setIsSubmitConfirmed(false); 
        toast.error("Failed to save the Adding Candidates." );
      } else if (savedRequest.status === 500) {
        setIsSubmitConfirmed(false); 
        toast.error("Failed to save the Adding Candidates." );
      } 
      else if (savedRequest.status === 409) {
        setIsSubmitConfirmed(false); 
        toast.error("The email is already associated with this request.." );
      }
      else {
        toast.success("New Candidates saved successfully!" );
    setIsModalSubmitOpen(false)
          onClose();  // Close the form

          setCandidate({
            full_name: "",
            email: "",
            phone_number: "",
            date_of_birth: "",
            gender: "",
            nationality: "",
            is_citizen: false,
            is_transfer_ownership: false,
            is_new_visa: false,
            source_of_cv: "",
            status: "",
            highest_degree: "",
            major: "",
            institute_name: "",
            completion_year: "",
            descriptions: "",
            company_name: "",
            reason_for_leaving: "",
            experience_years: "",
            experience_years_at_ksa: "",
            last_job_title: "",
            last_salary: "",
            expected_salary:"",
            Documents: {
              FileName: "",
              FileBase64: "",
              Size: 0,
              MimeType: "",
              reference_id: "0",
              process_type: "",
              uploaded_by: "",
              uploaded_at: "", // or null if you're using Date object
              IsActive: true
            }
          });
          setIsSubmitConfirmed(false); 
 
      }
    } catch (error) {
      console.error('Error saving hiring request:', error);
      toast.error("An error occurred while saving the hiring request." );
    }
  };
  
 

  const nextStep = () => {
    if (currentStep < 2) {
        const isValid = validateCurrentStep();
        if (isValid) {
          setCurrentStep((prevStep) => Math.min(prevStep + 1, stepContent.length - 1));
        }
    }
  };
const validateCurrentStep = () => {
  const currentStepErrors = {};
  const stepFields = getStepFields(currentStep); // Only active fields for the step

  const fieldsToSkip = [
    "institute_name",
    "completion_year",
    "company_name",
    "reason_for_leaving",
    "experience_years",
    "experience_years_at_ksa",
    "last_job_title",
    "last_salary","expected_salary","highest_degree","major","descriptions"
  ];

  stepFields.forEach((field) => {
    if (fieldsToSkip.includes(field)) return; // ❌ skip unnecessary fields

    const value = candidate[field];

    // Basic required check
    if (!value) {
      currentStepErrors[field] = `${field.replace(/_/g, " ")} is required.`;
    }

    // Phone number validation
    if (field === "phone_number" && value && isNaN(value)) {
      currentStepErrors[field] = "Phone number must be a valid number.";
    }

    // Email validation
    if (field === "email" && value) {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailPattern.test(value)) {
        currentStepErrors[field] = "Please enter a valid email address.";
      }
    }

    // Expected salary validation
    if (field === "expected_salary" && value && isNaN(value)) {
      currentStepErrors[field] = "Expected salary must be a number.";
    }
  });

  setErrors(currentStepErrors);
  return Object.keys(currentStepErrors).length === 0;
};

  
  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const getStepFields = (stepIndex) => {
    if (stepIndex === 0) {
      return ["full_name", "email", "phone_number", "date_of_birth", "gender", "source_of_cv", "nationality"];
    }
    if (stepIndex === 1) {
      return ["company_name", "experience_years", "experience_years_at_ksa", "last_job_title", "last_salary","expected_salary","highest_degree","major","institute_name","completion_year","descriptions","reason_for_leaving"];
    }
    if (stepIndex === 2) {
      return ["resume"]; // Adjust this if needed
    }
    return [];
  };

  const stepContent = [
    // Step 1: Personal Information
    (
        <div>
        

<div class="flex pb-6">
<h2 class="text-2xl  text-primary-800 text-center md:text-left">Personal Information</h2>

  <button
        onClick={onClose}
        className="ml-auto text-primary-800 bg-primary-800/20 hover:bg-primary-800 hover:text-white rounded-full w-8 h-8 flex items-center justify-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
</div>


         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
  {/* Full Name & Email */}
  {["full_name", "email"].map((field) => (
    <div key={field} className="mb-4">
      <label className="text-gray-500  py-1 font-medium text-base" htmlFor={field}>
        {field.replace(/_/g, " ").toUpperCase()}
      </label>
      <input
        type={field === "email" ? "email" : "text"}
        id={field}
        name={field}
        value={candidate[field]}
        onChange={handleChange}
        className="w-full  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none"
        placeholder={`Enter ${field.replace(/_/g, " ")}`}
      />
      {errors[field] && <p className="text-red-500 text-sm mt-1">{errors[field]}</p>}
    </div>
  ))}

  {/* Nationality with Searchable Dropdown */}
<div className="relative">
    <label className="text-gray-500  py-1 font-medium text-base" htmlFor="nationality">
      Nationality
    </label>
    <input
      type="text"
      id="nationality-search"
      name="nationality-search"
      placeholder="Search nationality..."
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setIsDropdownVisible(true);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" && filteredNationalities.length > 0) {
          handleSelectNationality(filteredNationalities[0]);
        }
      }} 
      className=" w-full  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none"
    />
    {isDropdownVisible && searchTerm && (
      <div className="absolute left-0 right-0 mt-1 bg-white border border-[#f5f3ef] rounded-md z-10">
        <NationalityList
          nationalities={filteredNationalities}
          onSelectNationality={handleSelectNationality}
          selectedNationality={candidate.nationality}
        />
      </div>
    )}
    {errors.nationality && <p className="text-red-500 text-sm mt-1">{errors.nationality}</p>}
  </div>

  {/* Phone, DOB, Gender, Source of CV */}
  {["phone_number", "date_of_birth", "gender", "source_of_cv"].map((field) => (
    <div key={field} className="mb-4">
      <label className="text-gray-500  py-1 font-medium text-base" htmlFor={field}>
        {field.replace(/_/g, " ").toUpperCase()}
      </label>

      {field === "gender" || field === "source_of_cv" ? (
        <select
          id={field}
          name={field}
          value={candidate[field]}
          onChange={handleChange}
          className="w-full  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none"
        >
          <option value="">Select {field.replace(/_/g, " ")}</option>
          {field === "gender" && (
            <>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </>
          )}
          {field === "source_of_cv" && (
            <>
              <option value="Third party">Third party</option>
              <option value="Reference">Reference</option>
              <option value="HR">HR</option>
            </>
          )}
        </select>
      ) : field === "phone_number" ? (
        <div className="flex space-x-2">
          <input
            type="text"
            id="country_code"
            name="country_code"
            value={candidate.country_code}
            onChange={handleChange}
            className="mt-1 p-2 w-1/3   py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none"
            placeholder="Country Code"
          />
          <input
            type="text"
            id="phone_number"
            name="phone_number"
            value={candidate.phone_number}
            onChange={handleChange}
            className="mt-1 p-2 w-2/3  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none"
            placeholder="Phone Number"
          />
        </div>
      ) : (
        <input
          type={field === "date_of_birth" ? "date" : "text"}
          id={field}
          name={field}
          value={candidate[field]}
          max={new Date().toISOString().split("T")[0]}
          onChange={handleChange}
          className="w-full  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none"
          placeholder={`Enter ${field.replace(/_/g, " ")}`}
        />
      )}

      {errors[field] && <p className="text-red-500 text-sm mt-1">{errors[field]}</p>}
    </div>
  ))}

  {/* Checkboxes */}
  <div className="mb-4 flex items-center space-x-3">
    <input
      type="checkbox"
      id="is_citizen"
      name="is_citizen"
      checked={candidate.is_citizen}
      onChange={handleChange}
      className="h-5 w-5 text-primary-600 border-gray-300 rounded focus:ring-1 focus:ring-primary-600"
    />
    <label htmlFor="is_citizen" className="text-sm font-medium text-primary-600">
      Is Citizen
    </label>
  </div>

  <div className="mb-4 flex items-center space-x-3">
    <input
      type="checkbox"
      id="is_transfer_ownership"
      name="is_transfer_ownership"
      checked={candidate.is_transfer_ownership}
      onChange={handleChange}
      className="h-5 w-5 text-primary-600 border-gray-300 rounded focus:ring-1 focus:ring-primary-600"
    />
    <label htmlFor="is_transfer_ownership" className="text-sm font-medium text-primary-600">
      Is Transfer Ownership
    </label>
  </div>

  <div className="mb-4 flex items-center space-x-3">
    <input
      type="checkbox"
      id="is_new_visa"
      name="is_new_visa"
      checked={candidate.is_new_visa}
      onChange={handleChange}
      className="h-5 w-5 text-primary-600 border-gray-300 rounded focus:ring-1 focus:ring-primary-600"
    />
    <label htmlFor="is_new_visa" className="text-sm font-medium text-primary-600">
      Is New Visa Required
    </label>
  </div>
</div>

      </div>
      
    ),
  
    // Step 2: Experience, Education, and Job Details
    (
        <div>


<div class="flex pb-6">
<h2 class="text-2xl  text-primary-800 text-center md:text-left"> Experience, Education, and Job Details</h2>

  <button
        onClick={onClose}
        className="ml-auto text-primary-800 bg-primary-800/20 hover:bg-primary-800 hover:text-white rounded-full w-8 h-8 flex items-center justify-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
</div>

        
       <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
  {[
    "company_name",
    "experience_years",
    "experience_years_at_ksa",
    "last_job_title",
    "last_salary",
    "expected_salary",
    "highest_degree",
    "major",
    "institute_name",
    "completion_year",
  ].map((field) => (
    <div key={field} className="mb-4">
      <label className="text-gray-500  py-1 font-medium text-base" htmlFor={field}>
        {field.replace(/_/g, " ").toUpperCase()}
      </label>

      {field === "completion_year" ? (
        <select
          id={field}
          name={field}
          value={candidate[field]}
          onChange={handleChange}
          className="w-full  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none"
        >
          {Array.from({ length: new Date().getFullYear() - 1950 + 1 }, (_, i) => 1950 + i).map(
            (year) => (
              <option key={year} value={year}>
                {year}
              </option>
            )
          )}
        </select>
      ) : field === "experience_years" || field === "experience_years_at_ksa" ? (
        <input
          type="number"
          id={field}
          name={field}
          value={candidate[field]}
          onChange={handleChange}
          className="w-full  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none"
          placeholder={`Enter ${field.replace(/_/g, " ")}`}
          min="0"
          step="1"
        />
      ) : field === "last_salary" || field === "expected_salary" ? (
        <input
          type="number"
          id={field}
          name={field}
          value={candidate[field]}
          onChange={handleChange}
          className="w-full  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none"
          placeholder={`Enter ${field.replace(/_/g, " ")}`}
          step="0.01"
          min="0"
        />
      ) : (
        <input
          type="text"
          id={field}
          name={field}
          value={candidate[field]}
          onChange={handleChange}
          className="w-full  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none"
          placeholder={`Enter ${field.replace(/_/g, " ")}`}
        />
      )}

      {errors[field] && <p className="text-red-500 text-sm">{errors[field]}</p>}
    </div>
  ))}
</div>

{/* Full row for descriptions */}
<div className="mb-4">
  <label className="text-gray-500  py-1 font-medium text-base" htmlFor="descriptions">
    DESCRIPTIONS
  </label>
  <textarea
    id="descriptions"
    name="descriptions"
    value={candidate.descriptions}
    onChange={handleChange}
    rows="4"
    className="w-full  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none break-words whitespace-normal"
    placeholder="Enter descriptions"
  />
  {errors.descriptions && <p className="text-red-500 text-sm">{errors.descriptions}</p>}
</div>

{/* Full row for reason_for_leaving */}
<div className="mb-4">
  <label className="text-gray-500  py-1 font-medium text-base" htmlFor="reason_for_leaving">
    REASON FOR LEAVING
  </label>
  <textarea
    id="reason_for_leaving"
    name="reason_for_leaving"
    value={candidate.reason_for_leaving}
    onChange={handleChange}
    rows="4"
    className="w-full  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none break-words whitespace-normal"
    placeholder="Enter reason for leaving"
  />
  {errors.reason_for_leaving && <p className="text-red-500 text-sm">{errors.reason_for_leaving}</p>}
</div>

      </div>
      
    ),
  
    // Step 3: Final Step - Submit (Upload Resume)
    (
        <div>
      <h3 className="text-2xl  text-primary-800 text-center md:text-left">
        Upload Your Resume and Submit
      </h3>
      <div className="mb-4">
        <label className="text-gray-500  py-1 font-medium text-base" htmlFor="resume">
          Upload Resume (PDF)
        </label>
        <input
          type="file"
          id="resume"
          name="resume"
          onChange={handleFileChange}
          accept="application/pdf"
          className="w-full  py-2 border px-2 border-primary-800/40 rounded-md text-grey-500 text-sm focus:outline-none"
        />
        {candidate.Documents.FileName && (
          <div className="mt-2 text-sm text-green-600">
            {candidate.Documents.FileName} ({(candidate.Documents.Size / 1024).toFixed(2)} KB)
          </div>
        )}

        {/* Display error for resume if any */}
        {errors.resume && <p className="text-red-500 text-sm">{errors.resume}</p>}

        {/* Handle file extraction button */}
        {candidate.resume && !isProcessing && (
          <button
            type="button"
           
            className="mt-2 text-primary-600 hover:bg-[#f5f3ef] border border-[#f5f3ef] px-4 py-2 rounded-md"
          >
            Extract Text from Resume
          </button>
        )}

        {/* Show processing state */}
        {isProcessing && <p className="mt-2 text-gray-500">Processing the PDF...</p>}

        {/* View button to open the modal */}
        {candidate.Documents.FileName && (
          <button
            type="button"
            onClick={openModal}
            className="mt-2 text-primary-600 hover:bg-[#f5f3ef] border border-[#f5f3ef] px-4 py-2 rounded-md"
          >
            View Resume
          </button>
        )}
      </div>

      {/* Modal to view the resume */}
      {isModalOpen && (
              <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full
    max-w-full
    sm:max-w-xl
    md:max-w-2xl
    lg:max-w-3xl
    xl:max-w-4xl
    2xl:max-w-5xl
    hd:max-w-6xl
    space-y-4">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-white bg-primary-600 hover:bg-primary-800 rounded-full w-8 h-8 flex items-center justify-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <h3 className="text-2xl text-primary-600 mb-4">Resume Preview</h3>
            <iframe
              src={`data:application/pdf;base64,${candidate.Documents.FileBase64}`}
              width="100%"
              height="500px"
              title="Resume Preview"
              className="border border-[#f5f3ef]"
            />
          </div>
        </div>
      )}
    </div>
    ),
  ];
  

  return (
    <div className="bg-white p-6 shadow-md border border-[#f5f3ef] w-full relative">
            
 
      {/* Render the current step's content */}
      {stepContent[currentStep]}
  
      <div className="flex justify-between mt-4">
        <button
          type="button"
          className="px-3 py-1 bg-white text-primary-800 border border-primary-500 hover:border-primary-800 hover:bg-primary-800/10 rounded disabled:opacity-30 transition"
          onClick={prevStep}
          disabled={currentStep === 0}
        >
          Previous
        </button>
  
        {/* Show Next button unless we're on the last step */}
        {currentStep < stepContent.length - 1 && (
          <button
            type="button"
            className="px-4 py-2 bg-primary-800 text-white px-6 py-2 rounded-md hover:bg-primary-800/60 transition"
            onClick={nextStep}
          >
            Next
          </button>
        )}
  
        {/* Show Finish button only on the last step */}
        {currentStep === stepContent.length - 1 && (
          <button
            type="button"
            className="px-4 py-2 bg-primary-800 text-white px-6 py-2 rounded-md hover:bg-primary-800/70"
            onClick={handleFinishClick}
          >
            Finish
          </button>
        )}
      </div>
    {/* Modal for confirmation */}
{isModalSubmitOpen && (
  <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-start z-50 pt-10">
    <div className="bg-white w-full lg:w-4/5 max-w-[1400px] rounded-lg shadow-md relative">

      {/* Close Button */}
      <button
        onClick={closesubmitModal}
        className="absolute top-4 right-4 text-white bg-primary-600 hover:bg-primary-800 rounded-full w-8 h-8 flex items-center justify-center shadow"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      {/* Title */}
      <h3 className="text-2xl text-primary-600 text-center font-semibold py-4 border-b border-gray-200">
        Review Candidate Details
      </h3>

      {/* Tabs */}
      <div className="flex justify-center mt-4 border-b border-gray-200">
        {["personal", "experience", "resume"].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-6 py-2 -mb-px font-medium border-b-2 transition-colors ${
              activeTab === tab
                ? "border-primary-600 text-primary-600"
                : "border-transparent text-gray-500 hover:text-primary-600"
            }`}
          >
            {tab === "personal" && "Personal Info"}
            {tab === "experience" && "Experience & Education"}
            {tab === "resume" && "Resume"}
          </button>
        ))}
      </div>

      {/* Tab Content */}
  {/* Tab Content */}
<div className="p-6   overflow-y-auto space-y-4">

  {activeTab === "personal" && (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {[
        { label: 'Full Name', value: candidate.full_name },
        { label: 'Email', value: candidate.email },
        { label: 'Phone Number', value: candidate.phone_number },
        { label: 'Date of Birth', value: candidate.date_of_birth },
        { label: 'Gender', value: candidate.gender },
        { label: 'Source Of CV', value: candidate.source_of_cv },
        { label: 'Nationality', value: candidate.nationality },
        { label: 'Is Citizen', value: candidate.is_citizen },
           { label: 'Is Visa Required', value: candidate.is_new_visa },
        { label: 'Is Transfer Ownership', value: candidate.is_transfer_ownership },
      ].map((item, idx) => (
        <div key={idx} className="flex flex-col border-b border-gray-100 p-2">
          <span className="text-primary-600 font-medium text-sm">{item.label}</span>
          <span className="text-primary-600 break-words whitespace-normal">{item.value || 'N/A'}</span>
        </div>
      ))}
    </div>
  )}

{activeTab === "experience" && (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    {[
      { label: 'Company Name', value: candidate.company_name },
      { label: 'Experience (Years)', value: candidate.experience_years },
      { label: 'Experience in KSA (Years)', value: candidate.experience_years_at_ksa },
      { label: 'Last Job Title', value: candidate.last_job_title },
      { label: 'Last Salary', value: candidate.last_salary },
      { label: 'Expected Salary', value: candidate.expected_salary },
      { label: 'Highest Degree', value: candidate.highest_degree },
      { label: 'Major', value: candidate.major },
      { label: 'Institute Name', value: candidate.institute_name },
      { label: 'Completion Year', value: candidate.completion_year },
    ].map((item, idx) => (
      <div key={idx} className="flex flex-col border-b border-gray-100 p-2">
        <span className="text-primary-600 font-medium text-sm">{item.label}</span>
        <span className="text-primary-600 break-words whitespace-normal">{item.value || 'N/A'}</span>
      </div>
    ))}

    {/* Notes */}
    <div className="flex flex-col border-b border-gray-100 p-2 col-span-full">
      <span className="text-primary-600 font-medium text-sm">Notes</span>
      <span className="text-primary-600 break-words whitespace-normal">{candidate.descriptions || 'N/A'}</span>
    </div>

    {/* Reason for Leaving */}
    <div className="flex flex-col border-b border-gray-100 p-2 col-span-full">
      <span className="text-primary-600 font-medium text-sm">Reason for Leaving</span>
      <span className="text-primary-600 break-words whitespace-normal">{candidate.reason_for_leaving || 'N/A'}</span>
    </div>
  </div>
)}


  {activeTab === "resume" && candidate.Documents?.FileName && (
    <div className="border border-gray-200   rounded-lg p-4">
      <iframe
        src={`data:application/pdf;base64,${candidate.Documents.FileBase64}`}
        width="100%"
        height="500px"
        title="Resume Preview"
        className="border rounded-md"
      />
    </div>
  )}

</div>


      {/* Footer Actions */}
      <div className="flex justify-end gap-4 p-6 border-t border-gray-200">
        <button
          onClick={closesubmitModal}
          className="px-4 py-2 bg-[#f5f3ef] text-gray-600 rounded-md hover:bg-primary-800/70 transition-colors"
        >
          Close
        </button>
        <button
          onClick={handleSubmit}
          disabled={isSubmitConfirmed}
          className={`px-4 py-2 rounded-md text-white transition-colors ${
            isSubmitConfirmed ? 'bg-gray-400 cursor-not-allowed' : 'bg-primary-800 hover:bg-primary-800/70'
          }`}
        >
          {isSubmitConfirmed ? 'Submitting...' : 'Submit'}
        </button>
      </div>

    </div>
  </div>
)}


  </div>
  
  );
};

 

 

 


  

 
 

 



 

  
  
  

  const HiringTable = ( ) => {
    const [selectedRequest, setSelectedRequest] = useState(null); // Track selected request
    const [IsAddCandidates, SetIsAddCandidates] = useState(false); // Toggle to show AddCandidateForm
    const [IsQuickAddCandidates, SetIsQuickAddCandidates] = useState(false); // Toggle to show AddCandidateForm
    const [openRequestId, setOpenRequestId] = useState(null); // Track dropdown per row
    const [selectedRow, setSelectedRow] = useState(null); // Track selected row for color change
    const dropdownRef = useRef(null); // Ref for the dropdown menu
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [hiringRequests, setHiringRequests] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [hiringManagers, setHiringManagers] = useState([]);
    const [DemandPlanning, setDemandPlanning] = useState([]);
    const [candidateRequests, setCandidateRequests] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [itemsPerPage, setItemsPerPage] = useState(10); // default is 10
    const [currentPage, setCurrentPage] = useState(1);
        const [hiringManageremail, sethiringManageremail] = useState("");
const [isModalVisible, setIsModalVisible] = useState(false);
const [activeTab, setActiveTab] = useState('details');
const [currentDocument, setCurrentDocument] = useState(null);

    // Handle outside click for closing the dropdown
      useEffect(() => {
   
    const userRole = getToken();

    const userName = getUserFromToken();
 
    const loadDepartments = async () => {
      try {
        
        const deptData = await fetchActiveDepartments();
        if (userRole.IsDepartmentRestricted === "True") {
            
          const departmentId = getDepartmentIdFromToken();
          setDepartments(deptData.filter(dept => String(dept.department_id) === String(departmentId)));
          selectedDepartment=Number(departmentId)
        } else {
            
          setDepartments(deptData);
        }
      } catch (err) {
        console.error("Failed to load departments:", err);
      }
    };

    const loadHiringManagers = async () => {
      try {
        const managers = await fetchHiringManagers();
        setHiringManagers(managers);
      } catch (err) {
        console.error("Failed to load hiring managers:", err);
      }
    };

    const loadDemandPlan = async () => {
      try {
        const currentYear = new Date().getFullYear();
        const dplan = await GetDemandPlanning(currentYear);
        setDemandPlanning(dplan);
      } catch (err) {
        console.error("Failed to load demand plan:", err);
      }
    };

const loadHiringRequests = async () => {
  try {
    const userRole = getToken(); // contains role and restriction info
    const requests = await fetchHiringRequests();

    // Extract required details
    const isDeptRestricted = userRole.IsDepartmentRestricted === "True";
    const userRoleName = userRole.role;
    const userId = userRole.user_id; // make sure your token has this
    const departmentId = getDepartmentIdFromToken();

    let filteredRequests = requests.filter(req => req.isConevrtToSource); // only sourced

    // Apply department restriction
    if (isDeptRestricted) {
      filteredRequests = filteredRequests.filter(
        req => String(req.department_id) === String(departmentId)
      );
    }

    // Apply recruiter filter for HR Specialist
    if (userRoleName === "HR Specialist") {
      filteredRequests = filteredRequests.filter(
        req => String(req.recruiter_id) === String(userId)
      );
    }

    setHiringRequests(filteredRequests);
  } catch (err) {
    console.error("Failed to load hiring requests:", err);
  } finally {
    // Optionally set loading to false, etc.
  }
};


    loadDepartments();
    loadHiringManagers();
    loadHiringRequests();
    loadDemandPlan();
  }, []);
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setOpenRequestId(null); // Close dropdown when clicking outside
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);
  
    const toggleMenu = (requestId) => {
      setOpenRequestId(openRequestId === requestId ? null : requestId);
      setSelectedRow(openRequestId === requestId ? null : requestId); // Change row color
    };
  
    // Handle edit (Add Candidate) form
    const handleEdit = (requestId) => {
      const request = hiringRequests.find(req => req.request_id === requestId);
      setSelectedRequest(request);
      SetIsAddCandidates(true); // Show AddCandidateForm
    };
        const handleQuickEdit = (requestId) => {
      const request = hiringRequests.find(req => req.request_id === requestId);
      setSelectedRequest(request);
      SetIsQuickAddCandidates(true); // Show AddCandidateForm
    };
const handleViewCandidates = async (requestId, request) => {
  try {
    const requests = await GetCandidateByRequestId(requestId); // fetch candidates
    setCandidateRequests(requests); 
    setSelectedRequest(request); // store selected request
    const email = hiringManagers.find(
      m => Number(m.user_id) === Number(request.hiring_manager)
    )?.email;
    sethiringManageremail(email); // store manager email
    setIsModalOpen(true); // open modal
  } catch (error) {
    console.error("Error fetching candidates:", error);
  }
};

const closeModal = () => {
  setIsModalVisible(false);
  setSelectedRequest(null);
  setCurrentDocument(null);
};

const handleBackdropClick = () => closeModal();

const handleView = (requestId) => {
  // Find the request by its ID
  const request = hiringRequests.find(req => req.request_id === requestId);
  
  if (!request) return; // Safety check

  // Set the selected request
  setSelectedRequest(request);

  // Show the modal
  setIsModalVisible(true);

  // Reset active tab to 'details' whenever you open a new request
  setActiveTab('details');
};

    
    const filteredRequests = hiringRequests.filter((request) => {
         
        if(selectedDepartment !='all'){
        const isDepartmentMatch =
          !selectedDepartment || request.department_id === selectedDepartment;
        const isSearchMatch =
          !searchQuery ||
          request.reason_for_hire.toLowerCase().includes(searchQuery.toLowerCase()) ||
          request.job_description.toLowerCase().includes(searchQuery.toLowerCase());
        return isDepartmentMatch && isSearchMatch;
        }
        else{
            const isSearchMatch =
            !searchQuery ||
            request.reason_for_hire.toLowerCase().includes(searchQuery.toLowerCase()) ||
            request.job_description.toLowerCase().includes(searchQuery.toLowerCase());
            return   isSearchMatch;
        }

  


      });

            const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);

const paginatedRequests = filteredRequests.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);
// Add this helper function at the top of your component
const getStatusColor = (status) => {
  switch(status?.toLowerCase()) {
    case 'approved':
      return { bg: 'rgba(34, 197, 94, 0.1)', text: 'rgb(22, 163, 74)' };
    case 'pending':
      return { bg: 'rgba(245, 158, 11, 0.1)', text: 'rgb(245, 158, 11)' };
    case 'rejected':
      return { bg: 'rgba(239, 68, 68, 0.1)', text: 'rgb(239, 68, 68)' };
    case 'draft':
      return { bg: 'rgba(156, 163, 175, 0.1)', text: 'rgb(107, 114, 128)' };
    case 'sourcing':
      return { bg: 'rgba(59, 130, 246, 0.1)', text: 'rgb(59, 130, 246)' };
    case 'offering':
      return { bg: 'rgba(168, 85, 247, 0.1)', text: 'rgb(168, 85, 247)' };
    case 'hold':
      return { bg: 'rgba(251, 191, 36, 0.1)', text: 'rgb(251, 191, 36)' };
    default:
      return { bg: 'rgba(156, 163, 175, 0.1)', text: 'rgb(107, 114, 128)' };
  }
};
const handleSubmit = (candidateData) => {
  // Handle candidate form submission here
  // For example, send candidateData to the API or update state
  //console.log('Candidate submitted:', candidateData);
  SetIsQuickAddCandidates(false); // Close modal after submit
};
  const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '##fff', // subtle light background matching header bg
    borderRadius: '0.75rem',    // rounded corners like your cards
    borderColor: state.isFocused ? '#8398A7' : '#53708550', // primary color on focus, gray default
    boxShadow: state.isFocused ? '0 0 0 1px #837550' : 'none',
    padding: '2px 8px',
    cursor: 'pointer',
    minHeight: '38px',
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '0.75rem',
    backgroundColor: 'white',
    boxShadow: '0 4px 10px rgba(131,117,80,0.15)', // subtle shadow with your theme color
    zIndex: 1000,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#E7EBEE' : 'white', // hover background like your rows
    color: '#0D4A76',
    cursor: 'pointer',
    padding: '8px 12px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#837550',
    fontWeight: '600',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#837550',
    ':hover': {
      color: '#b5a252',
    },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
};

    return (
        

   <div className="flex flex-col  2xl:px-[10%] pt-8 bg-white xl:pt-24 md:pt-8 md:rounded-t-[40px] xl:rounded-t-[48px] mx-4 h-[70vh] sm:h-[72vh] md:h-[74.5vh] lg:h-[74.5vh] xl:px-[calc(8%-1rem)] 3xl:px-[calc(8%-1rem)] 4xl:px-[calc(10%-1rem)] md:px-[calc(5%-1rem)]">
          <HiringSummary 
        hiringRequests={hiringRequests} 
        DemandPlanning={DemandPlanning} 
 
        departments={departments} 
      />




  {/* Department Select */}
 
        {/* Show AddCandidateForm when IsAddCandidates is true */}
        {IsAddCandidates ? (
       <AddCandidateForm
       requestId={selectedRequest?.request_id}
       companyCode={selectedRequest?.companyCode}
       onClose={() => SetIsAddCandidates(false)} // Hide AddCandidateForm
       nationalities={nationalities}
       addCandidate={(candidate) => {
         // Handle adding candidate (you can update the state or make an API call here)
        // console.log('Candidate added:', candidate);
         SetIsAddCandidates(false); // Close the form after submission
       }}
     />
     
        ) : (
            <div className="bg-white rounded-2xl p-6   filter drop-shadow-[0_5px_30px_rgba(10,60,96,0.10)]  ">
         <div className="p-4 rounded-lg ">

 <div className="flex items-center flex-col md:flex-col lg:flex-row gap-4 w-full">
  <h3 className="text-xl sm:text-2xl font-semibold w-full" style={{ color: 'rgb(18, 76, 114)' }}>
    Sourcing Details
  </h3>
  
  <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
    {/* Department Select */}
    <div className="flex-1 min-w-[200px]">
      <select
        value={selectedDepartment}
        onChange={(e) => setSelectedDepartment(e.target.value)}
        className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700 appearance-none"
        style={{ 
          borderColor: 'rgba(18, 76, 114, 0.3)',
          backgroundColor: 'white',
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%23124c72' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
          backgroundPosition: 'right 0.5rem center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '1.5em 1.5em',
          paddingRight: '2.5rem'
        }}
        onFocus={(e) => {
          e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
          e.target.style.borderColor = 'rgb(18, 76, 114)';
        }}
        onBlur={(e) => {
          e.target.style.boxShadow = 'none';
          e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
        }}
      >
        <option value="all" style={{ color: 'rgb(18, 76, 114)' }}>Select All</option>
        {departments.map((department) => (
          <option 
            key={department.department_id} 
            value={department.department_id}
            style={{ color: 'rgb(18, 76, 114)' }}
          >
            {department.department_name}
          </option>
        ))}
      </select>
    </div>

    {/* Search Input */}
    <div className="flex-1 min-w-[250px]">
      <input
        type="text"
        className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700 placeholder-gray-500"
        style={{ 
          borderColor: 'rgba(18, 76, 114, 0.3)',
          backgroundColor: 'white'
        }}
        placeholder="Search roles by Permission Path or Role ..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onFocus={(e) => {
          e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
          e.target.style.borderColor = 'rgb(18, 76, 114)';
        }}
        onBlur={(e) => {
          e.target.style.boxShadow = 'none';
          e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
        }}
      />
    </div>

    {/* Page Size Selector */}
    <div className="flex-1 min-w-[120px]">
      <select
        value={itemsPerPage}
        onChange={(e) => {
          setItemsPerPage(Number(e.target.value));
          setCurrentPage(1);
        }}
        className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700 appearance-none"
        style={{ 
          borderColor: 'rgba(18, 76, 114, 0.3)',
          backgroundColor: 'white',
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%23124c72' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
          backgroundPosition: 'right 0.5rem center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '1.5em 1.5em',
          paddingRight: '2.5rem'
        }}
        onFocus={(e) => {
          e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
          e.target.style.borderColor = 'rgb(18, 76, 114)';
        }}
        onBlur={(e) => {
          e.target.style.boxShadow = 'none';
          e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
        }}
      >
        {[5, 10, 20, 50].map((count) => (
          <option key={count} value={count} style={{ color: 'rgb(18, 76, 114)' }}>
            {count} / Page
          </option>
        ))}
      </select>
    </div>
  </div>
</div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
    
        
        {/* Department Dropdown */}



     
    </div>

 
 
</div>   
 
 
 
   <div className="bg-white p-4 rounded-2xl shadow-sm border" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>
  <div className="  rounded-lg">
    <table className="min-w-full table-auto border-collapse">
      <thead>
        <tr style={{ 
          background: 'linear-gradient(to right, rgba(18, 76, 114, 0.1), rgba(18, 76, 114, 0.05))',
          color: 'rgb(18, 76, 114)'
        }}>
          <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>Reference Number</th>
          <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>Req Type</th>
          <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>Department</th>
          <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>Role</th>
          <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>Manager</th>
          <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>Position</th>
          <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>Start Date</th>
          <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>Status</th>
          <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>Type</th>
          <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {paginatedRequests.map((request, index) => {
          const department = departments.find(dept => Number(dept.department_id) === Number(request.department_id))?.department_name;
          const hiringManager = hiringManagers.find(manager => Number(manager.user_id) === Number(request.hiring_manager))?.first_name;
          const roles = request.request_type === "Forecast"
            ? DemandPlanning.find(manager => Number(manager.demand_id) === Number(request.demand_id))?.role
            : request.role_text;
          
          return (
            <tr
              key={request.request_id}
              className={`transition-colors duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
              style={{ 
                backgroundColor: selectedRow === request.request_id ? 'rgba(18, 76, 114, 0.08)' : '',
                cursor: 'pointer'
              }}
              onClick={() => setSelectedRow(request.request_id)}
            >
              <td className="py-3 px-4 border-b text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.05)',
                color: 'rgb(18, 76, 114)',
                fontWeight: '500'
              }}>
                {request.referenceNumber}
              </td>
              <td className="py-3 px-4 border-b text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.05)',
                color: 'rgb(18, 76, 114)'
              }}>
                {request.request_type}
              </td>
              <td className="py-3 px-4 border-b text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.05)',
                color: 'rgb(18, 76, 114)'
              }}>
                {department}
              </td>
              <td className="py-3 px-4 border-b text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.05)',
                color: 'rgb(18, 76, 114)',
                fontWeight: '500'
              }}>
                {roles}
              </td>
              <td className="py-3 px-4 border-b text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.05)',
                color: 'rgb(18, 76, 114)'
              }}>
                {hiringManager}
              </td>
              <td className="py-3 px-4 border-b text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.05)',
                color: 'rgb(18, 76, 114)'
              }}>
                {request.position}
              </td>
              <td className="py-3 px-4 border-b text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.05)',
                color: 'rgb(18, 76, 114)'
              }}>
                {new Date(request.date_created).toLocaleDateString()}
              </td>
              <td className="py-3 px-4 border-b text-sm">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                  style={{
                    backgroundColor: getStatusColor(request.status).bg,
                    color: getStatusColor(request.status).text
                  }}
                >
                  {request.status}
                </span>
              </td>
              <td className="py-3 px-4 border-b text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.05)',
                color: 'rgb(18, 76, 114)'
              }}>
                {request.hiring_Type}
              </td>
              <td className="py-3 px-4 border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.05)' }}>
                <div className="relative">
                  <button
                    onClick={(e) => { e.stopPropagation(); toggleMenu(request.request_id); }}
                    className="px-3 py-1.5 border rounded-lg transition-all text-sm font-medium flex items-center gap-2"
                    style={{ 
                      borderColor: 'rgba(18, 76, 114, 0.3)',
                      color: 'rgb(18, 76, 114)',
                      backgroundColor: 'white'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'white';
                    }}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                    </svg>
                    Actions
                  </button>
                  
                  {openRequestId === request.request_id && (
                    <div 
                      ref={dropdownRef} 
                      className="absolute right-0 mt-1 bg-white border rounded-lg shadow-lg z-50 min-w-[200px]"
                      style={{ 
                        borderColor: 'rgba(18, 76, 114, 0.1)',
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
                      }}
                    >
                      <div className="py-2">
                        <button
                          onClick={() => handleView(request.request_id)}
                          className="w-full text-left px-4 py-2.5 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                          style={{ color: 'rgb(18, 76, 114)' }}
                        >
                          <div className="p-1.5 rounded-lg" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)' }}>
                            <svg className="w-4 h-4" style={{ color: 'rgb(18, 76, 114)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                          </div>
                          View Hiring Request
                        </button>
                        
                        {request && request.status !== "Offering" && (
                          <>
                            {/* <button hidden
                              onClick={() => handleEdit(request.request_id)}
                              className="w-full text-left px-4 py-2.5 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                              style={{ color: 'rgb(18, 76, 114)' }}
                            >
                              <div className="p-1.5 rounded-lg" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)' }}>
                                <svg className="w-4 h-4" style={{ color: 'rgb(18, 76, 114)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                                </svg>
                              </div>
                              Add Candidates
                            </button> */}
                            
                            <button
                              onClick={() => handleQuickEdit(request.request_id)}
                              className="w-full text-left px-4 py-2.5 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                              style={{ color: 'rgb(18, 76, 114)' }}
                            >
                              <div className="p-1.5 rounded-lg" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)' }}>
                                <svg className="w-4 h-4" style={{ color: 'rgb(18, 76, 114)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                </svg>
                              </div>
                                Add Candidates
                            </button>
                          </>
                        )}
                        
                        <button
                          onClick={() => handleViewCandidates(request.request_id, request)}
                          className="w-full text-left px-4 py-2.5 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                          style={{ color: 'rgb(18, 76, 114)' }}
                        >
                          <div className="p-1.5 rounded-lg" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)' }}>
                            <svg className="w-4 h-4" style={{ color: 'rgb(18, 76, 114)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          View Candidates
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
  
  {totalPages > 1 && (
    <div className="flex justify-center items-center mt-6 space-x-2">
      <button
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        disabled={currentPage === 1}
        className="px-3 py-1.5 bg-white border rounded-lg transition-all text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
        style={{ 
          borderColor: 'rgba(18, 76, 114, 0.3)',
          color: 'rgb(18, 76, 114)'
        }}
        onMouseEnter={(e) => {
          if (!e.currentTarget.disabled) {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
          }
        }}
        onMouseLeave={(e) => {
          if (!e.currentTarget.disabled) {
            e.currentTarget.style.backgroundColor = 'white';
          }
        }}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
        </svg>
        Previous
      </button>

      {Array.from({ length: totalPages }).map((_, i) => (
        <button
          key={i}
          onClick={() => setCurrentPage(i + 1)}
          className="px-3 py-1.5 border rounded-lg text-sm font-medium transition-all"
          style={{ 
            backgroundColor: currentPage === i + 1 ? 'rgb(18, 76, 114)' : 'white',
            borderColor: currentPage === i + 1 ? 'rgb(18, 76, 114)' : 'rgba(18, 76, 114, 0.3)',
            color: currentPage === i + 1 ? 'white' : 'rgb(18, 76, 114)'
          }}
          onMouseEnter={(e) => {
            if (currentPage !== i + 1) {
              e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
            }
          }}
          onMouseLeave={(e) => {
            if (currentPage !== i + 1) {
              e.currentTarget.style.backgroundColor = 'white';
            }
          }}
        >
          {i + 1}
        </button>
      ))}

      <button
        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
        disabled={currentPage === totalPages}
        className="px-3 py-1.5 bg-white border rounded-lg transition-all text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
        style={{ 
          borderColor: 'rgba(18, 76, 114, 0.3)',
          color: 'rgb(18, 76, 114)'
        }}
        onMouseEnter={(e) => {
          if (!e.currentTarget.disabled) {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
          }
        }}
        onMouseLeave={(e) => {
          if (!e.currentTarget.disabled) {
            e.currentTarget.style.backgroundColor = 'white';
          }
        }}
      >
        Next
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  )}
</div>
             
             
             </div>
        
        )}
        {IsQuickAddCandidates && (
  <QuickAddCandidateModal
    isOpen={IsQuickAddCandidates}
    onClose={() => SetIsQuickAddCandidates(false)}
    request_id={selectedRequest?.request_id}
      companyCode={selectedRequest?.companyCode}
    onSubmit={handleSubmit} // or your submit handler
  />
)}
  <CandidatesModal
        isOpen={isModalOpen} // Control modal visibility
        onClose={() => setIsModalOpen(false)} // Close modal
        candidates={candidateRequests} // Pass the candidates data
         hiringManageremail={hiringManageremail} 
         hiringRequests ={selectedRequest}
         
      />
   {isModalVisible && selectedRequest && (
  <div className="fixed inset-0 backdrop-blur-sm flex justify-center items-center z-50 p-4" style={{ backgroundColor: 'rgba(18, 76, 114, 0.2)' }}>
    <div 
      className="relative bg-white rounded-2xl shadow-2xl flex flex-col w-full max-w-full sm:max-w-xl md:max-w-2xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-5xl"
      style={{ 
        borderColor: 'rgba(18, 76, 114, 0.1)', 
        borderWidth: '1px',
  
      
       
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Modal Header */}
      <div className="flex items-center justify-between p-6 border-b rounded-t-2xl" style={{ 
        borderColor: 'rgba(18, 76, 114, 0.1)',
        background: 'linear-gradient(to right, rgba(18, 76, 114, 0.05), transparent)'
      }}>
        <h2 className="text-xl font-semibold" style={{ color: 'rgb(18, 76, 114)' }}>
          Request Details
        </h2>
        <button 
          onClick={closeModal}
          className="transition-all rounded-full p-1.5"
          style={{ color: 'rgba(18, 76, 114, 0.6)' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
            e.currentTarget.style.color = 'white';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = 'rgba(18, 76, 114, 0.6)';
          }}
          aria-label="Close"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Modal Body */}
      <div className="flex-1 overflow-hidden">
        {/* Tabs */}
        <div className="px-6 pt-4 pb-3">
          <div className="border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>
            <nav className="flex gap-2 -mb-px">
              {['details', 'jd'].map((tab) => (
                <button
                  key={tab}
                  className={`px-4 py-2 font-medium text-sm rounded-t-lg transition-all duration-300 ${
                    activeTab === tab
                      ? 'text-white'
                      : 'text-primary-800 hover:text-primary-600'
                  }`}
                  style={{
                    backgroundColor: activeTab === tab ? 'rgb(18, 76, 114)' : 'transparent',
                    borderColor: activeTab === tab ? 'rgb(18, 76, 114)' : 'transparent',
                  }}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === 'details' ? 'Details' : 'Job Description'}
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Scrollable Content Area */}
        <div className="h-full overflow-y-auto px-6 pb-4">
          {activeTab === 'details' && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-2">
              {/* Reference Number */}
              <div className="space-y-1">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Reference Number
                </label>
                <div className="px-3 py-2 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)'
                }}>
                  <span className="text-gray-800 text-sm font-medium break-words">{selectedRequest.referenceNumber}</span>
                </div>
              </div>

              {/* Request Type */}
              <div className="space-y-1">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Request Type
                </label>
                <div className="px-3 py-2 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)'
                }}>
                  <span className="text-gray-800 text-sm font-medium break-words">{selectedRequest.request_type}</span>
                </div>
              </div>

              {/* Department */}
              <div className="space-y-1">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Department
                </label>
                <div className="px-3 py-2 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)'
                }}>
                  <span className="text-gray-800 text-sm font-medium break-words">
                    {departments.find(dept => Number(dept.department_id) === Number(selectedRequest.department_id))?.department_name}
                  </span>
                </div>
              </div>

              {/* Role */}
              <div className="space-y-1">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Role
                </label>
                <div className="px-3 py-2 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)'
                }}>
                  <span className="text-gray-800 text-sm font-medium break-words">
                    {selectedRequest.request_type === "Forecast"
                      ? DemandPlanning.find(manager => Number(manager.demand_id) === Number(selectedRequest.demand_id))?.role || "N/A"
                      : selectedRequest.role_text || "N/A"}
                  </span>
                </div>
              </div>

              {/* Position */}
              <div className="space-y-1">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Position
                </label>
                <div className="px-3 py-2 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)'
                }}>
                  <span className="text-gray-800 text-sm font-medium break-words">{selectedRequest.position}</span>
                </div>
              </div>

              {/* Hiring Manager */}
              <div className="space-y-1">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Hiring Manager
                </label>
                <div className="px-3 py-2 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)'
                }}>
                  <span className="text-gray-800 text-sm font-medium break-words">
                    {hiringManagers.find(manager => Number(manager.user_id) === Number(selectedRequest.hiring_manager))?.first_name}
                  </span>
                </div>
              </div>

              {/* Planned Start Date */}
              <div className="space-y-1">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Planned Start Date
                </label>
                <div className="px-3 py-2 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)'
                }}>
                  <span className="text-gray-800 text-sm font-medium break-words">
                    {selectedRequest.planned_start_date ? new Date(selectedRequest.planned_start_date).toLocaleDateString() : 'N/A'}
                  </span>
                </div>
              </div>

              {/* Priority */}
              <div className="space-y-1">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Priority
                </label>
                <div className="px-3 py-2 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)'
                }}>
                  <span className="text-gray-800 text-sm font-medium break-words">{selectedRequest.priority}</span>
                </div>
              </div>

              {/* Hiring Type */}
              <div className="space-y-1">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Hiring Type
                </label>
                <div className="px-3 py-2 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)'
                }}>
                  <span className="text-gray-800 text-sm font-medium break-words">{selectedRequest.hiring_Type}</span>
                </div>
              </div>

              {/* Full Width Fields */}
              {/* Reason for Hire */}
              <div className="col-span-1 md:col-span-2 lg:col-span-3 space-y-1 mt-2">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Reason for Hire
                </label>
                <div className="px-3 py-3 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)',
                  minHeight: '80px'
                }}>
                  <p className="text-gray-800 text-sm font-medium whitespace-pre-line">{selectedRequest.reason_for_hire}</p>
                </div>
              </div>

              {/* Preferred Requirement */}
              {selectedRequest.request_type === "Exceptional" && (
                <div className="col-span-1 md:col-span-2 lg:col-span-3 space-y-1 mt-2">
                  <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                    Preferred Requirement
                  </label>
                  <div className="px-3 py-3 border rounded-lg" style={{ 
                    borderColor: 'rgba(18, 76, 114, 0.2)',
                    backgroundColor: 'rgba(18, 76, 114, 0.03)',
                    minHeight: '80px'
                  }}>
                    <p className="text-gray-800 text-sm font-medium whitespace-pre-line">{selectedRequest.preferred_requirment}</p>
                  </div>
                </div>
              )}

              {/* Notes */}
               
            </div>
          )}

          {activeTab === 'jd' && (
            <div className="pt-4">
              <JobDescription
                activeTab={activeTab}
                selectedRequest={selectedRequest.request_type === "Exceptional" ? selectedRequest : {
                  ...DemandPlanning.find(d => Number(d.demand_id) === Number(selectedRequest.demand_id)),
                  request_id: selectedRequest?.demand_id
                }}
                isEditMode={false}
                currentDocument={currentDocument || selectedRequest?.Documents}
              />
            </div>
          )}
        </div>
      </div>

      {/* Modal Footer */}
      <div className="flex justify-end p-6 border-t rounded-b-2xl" style={{ 
        borderColor: 'rgba(18, 76, 114, 0.1)',
        background: 'linear-gradient(to right, transparent, rgba(18, 76, 114, 0.05))'
      }}>
        <button
          onClick={closeModal}
          className="px-5 py-2.5 text-white font-medium rounded-lg transition-all"
          style={{ 
            backgroundColor: 'rgb(18, 76, 114)',
            cursor: 'pointer',
            boxShadow: '0 10px 15px -3px rgba(18, 76, 114, 0.2)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.9)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
          }}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

      </div>
      
    );
  };
  

 

  const HiringSummary = ({ hiringRequests, DemandPlanning, departments }) => {

    const userRole = getToken();

  //  const restrictedDepartmentId = userRole?.department_id; // Assuming userRole has department_id if restricted
    const restrictedDepartmentId = getDepartmentIdFromToken();
    
    const filteredHiringRequests = userRole.IsDepartmentRestricted === "True"
      ? hiringRequests.filter(request =>Number( request.department_id) === Number(restrictedDepartmentId))
      : hiringRequests;
  
    const filteredDemandPlanning = userRole.IsDepartmentRestricted === "True"
      ? DemandPlanning.filter(dp => Number(dp.department_id) === Number(restrictedDepartmentId))
      : DemandPlanning;
  
    return (




      <div>
<div className="relative ">
  {/* KPI Section */}
   <div className="xl:absolute z-10 w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8 -top-4 sm:-top-6 lg:-top-[155px]  items-stretch">
    <FlipCard
      label="Sourcing Requests "
    count={hiringRequests.length}
      imgSrc="/total-request.svg"
    />
    <FlipCard
      label="Pending Approval Requests"
      count={  filteredHiringRequests.filter(request => request.status === "Approved" && request.isConevrtToSource===true).length}
      imgSrc="/pending.svg"
    />
    <FlipCard
      label="Closed Count"
      count=  {filteredHiringRequests.filter(req => req.status === "Closed").length}
      imgSrc="/sourcing.svg"
    />
       <FlipCard
      label="Waiting For Hiring"
      count= {filteredHiringRequests.filter(req => req.status === "Approved").length}
      imgSrc="/sourcing.svg"
    />
    

  </div>
</div>




</div>
     
    );
  };

// Main HiringPage component
const SourcingPage = () => {

 
    // console.log(nationalities); // This will show the structure of the imported data
    // console.log(nationalities); // This should show the nationalities array
    // console.log(Array.isArray(nationalities)); // Check if nationalities is an array
 
 
    // console.log("console.log(Array.isArray(data.nationalities)); // Now this will work",Array.isArray(nationalities)); // Now this will work

 
 
  // Filter hiring requests based on department and search query




  
  return (
   <div className="flex flex-col  pt-8 gap-6">
 



      {/* Top Panels */}
    

  

      {/* Add New Request Button */}
   

      {/* Hiring Table */}
      <HiringTable
        
     
      />

      {/* New Hiring Request Form */}
  
    </div>
  );
};

export default SourcingPage;
